// src/lib/sms.js
import api from "@/lib/api";

/**
 * Wrapper peste backend:
 *  - POST /api/b/sms/send
 *  - GET  /api/b/sms/queue
 *
 * NOTE:
 * Axios interceptor-ul din src/lib/api.js pune automat X-Business-Id pe /b/*,
 * deci aici nu trebuie sa il mai trimitem manual.
 */

export async function sendSms({
  mode = "custom",
  appointmentId,
  clientId,
  toPhone,
  body,
  scheduledAt,
  force = false,
} = {}) {
  const payload = {
    mode,
    force: Boolean(force),
  };

  if (appointmentId !== undefined && appointmentId !== null && String(appointmentId) !== "") {
    payload.appointment_id = Number(appointmentId);
  }

  if (clientId !== undefined && clientId !== null && String(clientId) !== "") {
    payload.client_id = Number(clientId);
  }

  if (toPhone) payload.to_phone = String(toPhone);
  if (body) payload.body = String(body);
  if (scheduledAt) payload.scheduled_at = String(scheduledAt);

  const res = await api.post("/b/sms/send", payload);
  return res?.data;
}

export async function listSmsQueue({
  status = "pending,sending,failed",
  limit = 200,
} = {}) {
  const res = await api.get("/b/sms/queue", {
    params: {
      status,
      limit,
    },
  });
  return res?.data;
}
